// extracted by mini-css-extract-plugin
export var avatar = "_nz-3";
export var avatarContainer = "_nz-2";
export var avatarSpacer = "_nz-5";
export var avatarSpacerContainer = "_nz-4";
export var avatarStackContainer = "_nz-1";
export var bubble = "_nz-0";
export var remainderBubble = "_nz-6";